import { useAtom } from '@reatom/npm-react'
import { useState } from 'react'
import { Controller } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { EditIcon } from '@blade/ui-kit'
import { Input } from '@root/shared/ui-kit'

import { EditWalletPanelItem } from './edit-wallet-panel-item'

import type { EditWalletValues } from './edit-wallet'
import type { WalletModel } from '@root/entities/wallet'
import type { Control } from 'react-hook-form'

type Props = {
  wallet: WalletModel
  walletName: string
  control: Control<EditWalletValues>
}

export const EditWalletName: React.FC<Props> = ({
  wallet,
  control,
  walletName,
}) => {
  const [currentName] = useAtom(wallet.name)
  const { t } = useTranslation()
  const [isEditing, setIsEditing] = useState(false)

  return (
    <Root
      title={t('wallet.rename_wallet_short')}
      notInteractive
      icon={<EditIcon size={16} />}
      endContent={
        isEditing ? (
          <Controller
            control={control}
            name="name"
            rules={{ minLength: 2, maxLength: 32, required: true }}
            render={({ field }) => (
              <InputName
                size="s"
                autoFocus
                {...field}
                onBlur={() => {
                  if (!field.value) {
                    field.onChange(currentName)
                  }
                  field.onBlur()
                  setIsEditing(false)
                }}
              />
            )}
          />
        ) : (
          <WalletName onClick={() => setIsEditing(true)}>
            {walletName}
          </WalletName>
        )
      }
    />
  )
}

const Root = styled(EditWalletPanelItem)`
  padding-inline: 12px 6px;
  grid-template-columns: auto 1fr auto;
`

const WalletName = styled.div`
  color: var(--text-11);

  cursor: pointer;

  border-radius: 6px;
  background: var(--appearanceA-5);

  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
  padding: 4px 6px;
`

const InputName = styled(Input)`
  --input-height: 30px;
  --input-border-radius: 6px;
`
